import React, { useContext } from 'react';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ProgressBar, Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

import { getPreviewShimmerStyles } from '../styles/preview-shimmer-styles';

const IntroShimmer = ({ displayMode }) => (
  <div className="intro-shimmer" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '47px', width: displayMode === 's' ? '340px' : '393px' }} /> </Skeleton>
    <div style={{ display: 'flex', gap: '4px' }}>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '115px' : '164px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '21px' : '30px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '133px' : '190px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '45px' : '64px' }} /> </Skeleton>
    </div>
    <div style={{ display: 'flex', gap: '4px' }}>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '67px' : '96px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '84px' : '120px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '73px' : '104px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '110px' : '157px' }} /> </Skeleton>
    </div>
    <div style={{ display: 'flex', gap: '4px' }}>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '115px' : '164px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '21px' : '30px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '133px' : '190px' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '19px', width: displayMode === 's' ? '45px' : '64px' }} /> </Skeleton>
    </div>
    <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '23px', width: '202px' }} /> </Skeleton>
    <div className="circle-shimmers" style={{ display: 'flex', gap: '4px' }}>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '48px', width: '48px', borderRadius: '50%' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '48px', width: '48px', borderRadius: '50%' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '48px', width: '48px', borderRadius: '50%' }} /> </Skeleton>
      <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '48px', width: '48px', borderRadius: '50%' }} /> </Skeleton>
    </div>
  </div>
);

const PlacementShimmer = ({ displayMode }) => (
  <Skeleton className="placement-shimmer">
    <SkeletonItem style={{ height: '325px', width: displayMode === 's' ? '340px' : '410px' }} />
  </Skeleton>
);

const ButtonShimmer = ({ displayMode }) => (
  <Skeleton className="button-shimmer">
    <SkeletonItem style={{ height: '70px', width: displayMode === 's' ? '210px' : '350px' }} />
  </Skeleton>
);

const InputShimmer = ({ displayMode }) => (
  <div className="input-shimmer" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
    <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '32px', width: '180px' }} /> </Skeleton>
    <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '50px', width: displayMode === 's' ? '340px' : '524px' }} /> </Skeleton>
    <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '32px', width: '180px' }} /> </Skeleton>
  </div>
);

export function PreviewShimmer() {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getPreviewShimmerStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);

  return (
    <div className={classNames('preview-shimmer-container', classes.shimmerContainer, classes[`shimmerContainer-${displayMode}`])}>
      <h1 className="shimmer-title">
        {i18n.getString(_TL_('Explore ads options lightning fast with AI'))}
      </h1>
      <p className="shimmer-description">
        {i18n.getString(_TL_('Give us a moment while we scan your website and generate ads for you.'))}
      </p>
      <ProgressBar className="shimmer-progress" />
      <InputShimmer displayMode={displayMode} />
      <div className={classNames('ads-shimmer', classes.adsShimmer, classes[`adsShimmer-${displayMode}`])}>
        <IntroShimmer displayMode={displayMode} />
        <PlacementShimmer displayMode={displayMode} />
      </div>
      <ButtonShimmer displayMode={displayMode} />
    </div>
  );
}
